import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import './style.scss'

const CustomTab = ({ headers, children }) => {
  return (
    <Tabs>
      <TabList>
        {headers.map((item) => {
          return <Tab key={item.key}>{item.label}</Tab>
        })}
      </TabList>
      {children.map((item, index) => {
        return (
          <TabPanel key={index} className="custom-tab-panel">
            {item}
          </TabPanel>
        )
      })}
    </Tabs>
  )
}

export default CustomTab
